import React, { useState } from "react";

const Acreditaciones = () => {
  const [formData, setFormData] = useState({
    medio: "",
    medioTipo: "",
    emailMedio: "",
    telefono: "",
    nombre: "",
    apellido: "",
    dni: "",
    funcion: "",
    email: "",
    telefonoPersonal: "",
    foto: null,
  });

  const [integrantes, setIntegrantes] = useState([]);

  // ==========================================
  // MANEJAR CAMBIOS DEL FORMULARIO
  // ==========================================

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  // ==========================================
  // CAMBIAR TIPO DE MEDIO
  // ==========================================

  const cambiarTipoMedio = (e) => {
    const nuevoTipo = e.target.value;

    setFormData({
      ...formData,
      medioTipo: nuevoTipo,
    });

    // Reiniciamos integrantes cuando cambia
    // el tipo de medio
    setIntegrantes([]);
  };

  // ==========================================
  // AGREGAR INTEGRANTE
  // ==========================================

  const agregarIntegrante = () => {
    setIntegrantes([
      ...integrantes,
      {
        nombre: "",
        apellido: "",
        dni: "",
        funcion: "",
        foto: null,
      },
    ]);
  };

  // ==========================================
  // ELIMINAR INTEGRANTE
  // ==========================================

  const eliminarIntegrante = (index) => {
    setIntegrantes(
      integrantes.filter((_, i) => i !== index)
    );
  };

  // ==========================================
  // ACTUALIZAR INTEGRANTE
  // ==========================================

  const actualizarIntegrante = (
    index,
    campo,
    valor
  ) => {
    const nuevosIntegrantes = [...integrantes];

    nuevosIntegrantes[index] = {
      ...nuevosIntegrantes[index],
      [campo]: valor,
    };

    setIntegrantes(nuevosIntegrantes);
  };

  // ==========================================
  // OBTENER FUNCIONES SEGÚN MEDIO
  // ==========================================

  const obtenerFunciones = () => {
    switch (formData.medioTipo) {
      case "radial":
        return [
          {
            value: "periodista",
            label: "Periodista",
          },
          {
            value: "tecnico",
            label: "Técnico",
          },
        ];

      case "television":
        return [
          {
            value: "camara",
            label: "Cámara",
          },
          {
            value: "notero",
            label: "Notero",
          },
        ];

      case "prensa-escrita":
        return [
          {
            value: "periodista",
            label: "Periodista",
          },
          {
            value: "fotografo",
            label: "Fotógrafo",
          },
        ];

      case "digital":
        return [
          {
            value: "periodista",
            label: "Periodista",
          },
          {
            value: "fotografo",
            label: "Fotógrafo",
          },
        ];

      default:
        return [];
    }
  };

  // ==========================================
  // VALIDAR FUNCIONES
  // ==========================================

  const validarFunciones = () => {
    return null;
  };

  // ==========================================
  // VALIDAR CAMPOS DE INTEGRANTES
  // ==========================================

  const validarIntegrantes = () => {
    for (let i = 0; i < integrantes.length; i++) {
      const integrante = integrantes[i];

      if (
        !integrante.nombre ||
        !integrante.apellido ||
        !integrante.dni ||
        !integrante.funcion
      ) {
        return (
          `Completá todos los datos del Integrante ${
            i + 2
          }.`
        );
      }
    }

    return null;
  };

  // ==========================================
// ENVIAR FORMULARIO
// ==========================================

const handleSubmit = async (e) => {
  e.preventDefault();

  const errorIntegrantes = validarIntegrantes();
  if (errorIntegrantes) {
    alert(errorIntegrantes);
    return;
  }

  const errorFunciones = validarFunciones();
  if (errorFunciones) {
    alert(errorFunciones);
    return;
  }

  if (!formData.foto) {
    alert("La foto del responsable es obligatoria.");
    return;
  }

  for (let i = 0; i < integrantes.length; i++) {
    if (!integrantes[i].foto) {
      alert(`La foto del Integrante ${i + 2} es obligatoria.`);
      return;
    }
  }

  const solicitud = {
    medio: formData.medio,
    medioTipo: formData.medioTipo,
    emailMedio: formData.emailMedio,
    telefono: formData.telefono,
    responsable: {
      nombre: formData.nombre,
      apellido: formData.apellido,
      dni: formData.dni,
      funcion: formData.funcion,
      email: formData.email,
      telefono: formData.telefonoPersonal,
    },
    integrantes: integrantes.map((integrante) => ({
      nombre: integrante.nombre,
      apellido: integrante.apellido,
      dni: integrante.dni,
      funcion: integrante.funcion,
      email: "",
      telefono: "",
    })),
  };

  const formDataEnviar = new FormData();
  formDataEnviar.append("solicitud", JSON.stringify(solicitud));
  formDataEnviar.append("responsableFoto", formData.foto);

  integrantes.forEach((integrante) => {
    formDataEnviar.append("integrantesFotos", integrante.foto);
  });

  try {
    const response = await fetch(
      "https://mediumpurple-hamster-254578.hostingersite.com/acreditaciones",
      {
        method: "POST",
        body: formDataEnviar,
      }
    );

    const data = await response.json();

    if (!response.ok) {
      alert(data.mensaje || "Error al enviar la solicitud");
      return;
    }

    console.log("Solicitud guardada:", data);
    alert(
      "Solicitud enviada correctamente. " +
      "El Departamento de Prensa evaluará su solicitud."
    );

    setFormData({
      medio: "",
      medioTipo: "",
      emailMedio: "",
      telefono: "",
      nombre: "",
      apellido: "",
      dni: "",
      funcion: "",
      email: "",
      telefonoPersonal: "",
      foto: null,
    });
    setIntegrantes([]);
  } catch (error) {
    console.error("Error al enviar la acreditación:", error);
    alert("No se pudo enviar la solicitud.");
  }
};
  // ==========================================
  // RENDER
  // ==========================================

  return (
    <div className="acreditaciones-page">

      {/* ======================================
          ENCABEZADO
      ====================================== */}

      <section className="acreditaciones-header">
        <h1>ACREDITACIONES DE PRENSA</h1>
        <h2>Temporada 2026/2027</h2>
      </section>

      <section className="acreditaciones-contenido">

        {/* ====================================
            INFORMACIÓN
        ==================================== */}

        <div className="comunicado">

          <h2>Información importante</h2>

          <p>
            El Departamento de Prensa de la
            Asociación Atlética Quimsa informa
            que se encuentra abierto el proceso
            de acreditaciones para la temporada
            2026/2027.
          </p>

          <p>
            Los medios interesados deberán
            completar los datos del personal
            que solicita acreditación.
          </p>

          <p className="fecha-limite">
            Fecha límite:  Jueves 17 de septiembre de
            2026, sin excepción.
          </p>

          <h3>Requisitos del personal</h3>

          <ul>
            <li>
              <strong>Medios radiales:</strong>{" "}
              deben incluir al menos un técnico.
            </li>

            <li>
              <strong>
                Medios televisivos:
              </strong>{" "}
              deben incluir al menos una cámara y un
              notero.
            </li>

            <li>
              <strong>
                Prensa escrita:
              </strong>{" "}
              al menos 1 periodista y 1 fotógrafo.
            </li>

            <li>
              <strong>
                Medios digitales:
              </strong>{" "}
                al menos 1 periodista y 1 fotógrafo.
            </li>
          </ul>

          <div className="advertencia">
            El pedido de acreditación no
            garantiza su aceptación.
          </div>

        </div>

        {/* ====================================
            FORMULARIO
        ==================================== */}

        <form
          onSubmit={handleSubmit}
          className="form-acreditacion"
        >

          <h2>
            Solicitud de acreditación
          </h2>

          {/* DATOS DEL MEDIO */}

          <h3>Datos del medio</h3>

          <label>
            Nombre del medio *
          </label>

          <input
            type="text"
            name="medio"
            value={formData.medio}
            onChange={handleChange}
            placeholder="Ej. Radio Quimsa"
            required
          />

          <label>
            Tipo de medio *
          </label>

          <select
            name="medioTipo"
            value={formData.medioTipo}
            onChange={cambiarTipoMedio}
            required
          >
            <option value="">
              Seleccionar
            </option>

            <option value="radial">
              Medio radial
            </option>

            <option value="television">
              Medio televisivo
            </option>

            <option value="prensa-escrita">
              Prensa escrita
            </option>

            <option value="digital">
              Medio digital
            </option>
          </select>

          <label>
            Email del medio *
          </label>

          <input
            type="email"
            name="emailMedio"
            value={formData.emailMedio}
            onChange={handleChange}
            placeholder="medio@email.com"
            required
          />

          <label>
            Teléfono de contacto *
          </label>

          <input
            type="tel"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            placeholder="Teléfono"
            required
          />

          <hr />

          {/* RESPONSABLE */}

          <h3>
            Responsable de la solicitud
          </h3>

          <label>
            Nombre *
          </label>

          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
          />

          <label>
            Apellido *
          </label>

          <input
            type="text"
            name="apellido"
            value={formData.apellido}
            onChange={handleChange}
            required
          />

          <label>
            DNI *
          </label>

          <input
            type="text"
            name="dni"
            value={formData.dni}
            onChange={handleChange}
            required
          />

          <label>
            Función *
          </label>

          <select
            name="funcion"
            value={formData.funcion}
            onChange={handleChange}
            required
          >
            <option value="">
              Seleccionar función
            </option>

            {obtenerFunciones().map(
              (funcion) => (
                <option
                  key={funcion.value}
                  value={funcion.value}
                >
                  {funcion.label}
                </option>
              )
            )}
          </select>

          <label>
            Foto carnet digital *
          </label>

          <input
            type="file"
            name="foto"
            accept="image/*"
            onChange={handleChange}
            required
          />

          <label>
            Email personal
          </label>

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="correo@email.com"
          />

          <label>
            Teléfono personal
          </label>

          <input
            type="tel"
            name="telefonoPersonal"
            value={formData.telefonoPersonal}
            onChange={handleChange}
            placeholder="Teléfono"
          />

          {/* ==================================
              INTEGRANTES ADICIONALES
          ================================== */}

          {formData.medioTipo && (
              <>
                <hr />

                <h3>
                  Integrantes adicionales
                </h3>

                <p>Podés agregar todos los integrantes necesarios.</p>

                {integrantes.map(
                  (integrante, index) => (
                    <div
                      className="integrante"
                      key={index}
                    >

                      <h4>
                        Integrante {index + 2}
                      </h4>

                      <label>
                        Nombre *
                      </label>

                      <input
                        type="text"
                        value={
                          integrante.nombre
                        }
                        onChange={(e) =>
                          actualizarIntegrante(
                            index,
                            "nombre",
                            e.target.value
                          )
                        }
                        required
                      />

                      <label>
                        Apellido *
                      </label>

                      <input
                        type="text"
                        value={
                          integrante.apellido
                        }
                        onChange={(e) =>
                          actualizarIntegrante(
                            index,
                            "apellido",
                            e.target.value
                          )
                        }
                        required
                      />

                      <label>
                        DNI *
                      </label>

                      <input
                        type="text"
                        value={
                          integrante.dni
                        }
                        onChange={(e) =>
                          actualizarIntegrante(
                            index,
                            "dni",
                            e.target.value
                          )
                        }
                        required
                      />

                      <label>
                        Función *
                      </label>

                      <select
                        value={
                          integrante.funcion
                        }
                        onChange={(e) =>
                          actualizarIntegrante(
                            index,
                            "funcion",
                            e.target.value
                          )
                        }
                        required
                      >
                        <option value="">
                          Seleccionar función
                        </option>

                        {obtenerFunciones().map(
                          (funcion) => (
                            <option
                              key={
                                funcion.value
                              }
                              value={
                                funcion.value
                              }
                            >
                              {
                                funcion.label
                              }
                            </option>
                          )
                        )}
                      </select>

                      <label>
                        Foto carnet digital *
                      </label>

                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          actualizarIntegrante(
                            index,
                            "foto",
                            e.target.files[0]
                          )
                        }
                        required
                      />

                      <button
                        type="button"
                        onClick={() =>
                          eliminarIntegrante(
                            index
                          )
                        }
                      >
                        Eliminar integrante
                      </button>

                    </div>
                  )
                )}

                <button
                  type="button"
                  className="btn-agregar"
                  onClick={agregarIntegrante}
                >
                  + Agregar integrante
                </button>

              </>
            )}

          {/* ==================================
              ACEPTACIÓN
          ================================== */}

          <div className="aceptacion">

            <label>

              <input
                type="checkbox"
                required
              />

              <span>
                Declaro que los datos
                proporcionados son correctos
                y entiendo que el pedido de
                acreditación no garantiza su
                aceptación.
              </span>

            </label>

          </div>

          {/* ==================================
              ENVIAR
          ================================== */}

          <button
            type="submit"
            className="btn-enviar"
          >
            ENVIAR SOLICITUD
          </button>

        </form>

      </section>

    </div>
  );
};

export default Acreditaciones;